export default [
    {
      path: "viatic",
      name: "rrhh-viatic",
      redirect: { name: "rrhh-viatic-pending" },
      component: () => import("@/views/monitoring/views/viatic/Viatic.vue"),
      meta: {
        section: 6,
        pageTitle: "Viatic",
        breadcrumb: [
          {
            text: "Pending",
          },
        ],
        tabs: [
          {
            title: "Pending",
            name: "rrhh-viatic-pending",
          },
          {
            title: "Approved",
            name: "rrhh-viatic-approved",
          },
        ],
      },
      children: [
        {
          path: "pending",
          name: "rrhh-viatic-pending",
          component: () =>
            import(
              /* webpackChunkName: "RrhhViaticPending" */ "@/views/monitoring/views/viatic/components/TabViatic.vue"
            ),
          meta: {
            status_viatic: 1,
            section: 6,
            pageTitle: "Viatic",
            breadcrumb: [
              {
                text: "Pending",
                active: true
              },
            ],
          },
        },
        {
          path: "approved",
          name: "rrhh-viatic-approved",
          component: () =>
            import(
              /* webpackChunkName: "RrhhViaticApproved" */ "@/views/monitoring/views/viatic/components/TabViatic.vue"
            ),
          meta: {
            status_viatic: 2,
            section: 6,
            pageTitle: "Viatic",
            breadcrumb: [
              {
                text: "Approved",
                active: true,
              },
            ],
          },
        },
      ],
    },
  ];
  